/* eslint-disable no-console */
import addCartLimitModal from './cart-limit-modal';
import { addToCart, getCartItems, removeFromCart } from '../cart';
import InitMiniCart from '../mini-cart';

const ADD = 'add';
const REMOVE = 'remove';

const updateCartStatusMessage = (action) => {
  const msgDiv = document.querySelector('.main-nav .cart-status-message');
  if (!msgDiv) {
    return;
  }
  // Clear existing message
  msgDiv.innerHTML = '';
  setTimeout(() => {
    if (action === ADD) {
      msgDiv.innerHTML = 'An item has been added to your cart.';
    }
    if (action === REMOVE) {
      msgDiv.innerHTML = 'An Item has been removed from your cart.';
    }
  }, 100);
};

const updateCartButtonLabel = (btn, action) => {
  const assetName = btn.getAttribute('data-colorName');
  if (action === REMOVE) {
    btn.innerHTML = `<span class="sr-only">Remove ${assetName} Sample</span>In Cart`;
  } else {
    btn.innerHTML = `<span class="sr-only">Add </span>Free Sample<span class="sr-only">Of ${assetName} To Cart</span>`;
  }
};

const updateCartState = () => {
  getCartItems()
    .then((cart) => {
      const btns = document.querySelectorAll('.swatch-cart-btn');
      btns.forEach((btn) => {
        btn.classList.remove('add-to-cart-btn');
        btn.classList.remove('remove-from-cart-btn');
        btn.innerHTML = '';

        const inCart = cart.items.includes(btn.getAttribute('data-swatchKey'));
        if (inCart) {
          btn.classList.add('remove-from-cart-btn');
          updateCartButtonLabel(btn, REMOVE);
        } else {
          btn.classList.add('add-to-cart-btn');
          updateCartButtonLabel(btn, ADD);
        }
      });
    })
    .catch(console.error);
};

const updateMiniCart = () => {
  const url = `${window.location.protocol}//${window.location.hostname}/cart/MiniCartDetails`;
  fetch(url)
    .then(r => r.text())
    .then((html) => {
      const miniCartDiv = document.querySelector('.cart-content-wrap');
      if (!miniCartDiv) {
        return;
      }

      miniCartDiv.innerHTML = html;
      InitMiniCart();
    })
    .catch(console.error);
};

const toggleAddToCartButton = (btn, action) => {
  if (action === REMOVE) {
    btn.classList.add('remove-from-cart-btn');
    btn.classList.remove('add-to-cart-btn');
  } else {
    btn.classList.remove('remove-from-cart-btn');
    btn.classList.add('add-to-cart-btn');
  }
  updateCartButtonLabel(btn, action);
};

const updateSiteCartButtons = () => {
  getCartItems()
    .then((cart) => {
      const btns = document.querySelectorAll('.site-cart-btn');
      btns.forEach((btn) => {
        if (cart.items.length) {
          btn.classList.add('items-added-to-cart');
        } else {
          btn.classList.remove('items-added-to-cart');
        }
      });
    })
    .catch(console.error);
};

const setupCartActions = () => {
  updateSiteCartButtons();
  const btns = document.querySelectorAll('.swatch-cart-btn');
  btns.forEach((btn) => {
    btn.onclick = (e) => {
      const code = e.target.getAttribute('data-swatchKey');
      if (e.target.classList.contains('add-to-cart-btn')) {
        addToCart(code)
          .then(() => {
            toggleAddToCartButton(e.target, REMOVE);
            updateMiniCart();
            updateCartStatusMessage('add');
            updateSiteCartButtons();
          })
          .catch((err) => {
            const p = document.createElement('p');
            p.innerHTML = `<strong>WE'RE SORRY:</strong> ${err.msg}`;

            const a = document.createElement('a');
            if (err.phone) {
              a.href = `tel:${err.phone}`;
              a.innerText = err.phone;
              p.innerHTML = `${p.innerHTML} If the problem persists, please contact support at&nbsp;`;
            } else {
              a.href = '/find-a-dealer';
              a.innerText = 'contact a dealer';
              p.innerHTML = `${p.innerHTML} If you need more assistance in choosing the right color,&nbsp;`;
            }

            p.appendChild(a);

            const wrap = document.createElement('div');
            wrap.appendChild(p);

            addCartLimitModal({
              message: wrap.innerHTML,
            });
          });
      } else if (e.target.classList.contains('remove-from-cart-btn')) {
        removeFromCart(code)
          .then(() => {
            toggleAddToCartButton(e.target, ADD);
            updateMiniCart();
            updateCartStatusMessage('remove');
            updateSiteCartButtons();
          })
          .catch(console.error);
      }
    };
  });
};

export {
  setupCartActions,
  toggleAddToCartButton,
  updateCartButtonLabel,
  updateCartState,
  updateCartStatusMessage,
  updateMiniCart,
};
/* eslint-disable no-console */
